import React, { useEffect, useRef, useState } from 'react';
import './UserMenu.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getOdUserInfoRequest } from '../../../../actionCreators/user';
import UserName from '../UserName/UserName';
import Dropdown from '../Dropdown/Dropdown';

const UserMenu = () => {
  const [toggleDropdown, setToggleDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const { result: user, loading, error } = useSelector(state => state.user);
  const dispatch = useDispatch();

  const cachedUserRef = useRef(null);

  useEffect(() => {
    if (user?.firstName || user?.lastName) {
      cachedUserRef.current = user;
    }
  }, [user]);

  useEffect(() => {
    dispatch(getOdUserInfoRequest());
  }, []);

  useEffect(() => {
    const handleClickOutside = event => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setToggleDropdown(false);
      }
    };

    if (toggleDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [toggleDropdown]);

  const displayUser = loading ? cachedUserRef.current : user;

  if (!displayUser) {
    return (
      <a className="odUserMenu__login" href="/sg/en/customer/account/login">
        Login
      </a>
    );
  }

  return (
    <div ref={dropdownRef} className="odUserMenu">
      <UserName
        toggleDropdown={toggleDropdown}
        user={user}
        onClick={() => setToggleDropdown(prevState => !prevState)}
      />
      <Dropdown toggleDropdown={toggleDropdown} user={user} />
    </div>
  );
};

export default UserMenu;
